export const POST_FORM_MODAL_ACTIONS = {
    VIEW_POST_FORM_COLLECTION: "VIEW_POST_FORM_COLLECTION",
    ADD_POST_FORM_COLLECTION: "ADD_POST_FORM_COLLECTION",
    DELETE_POST_FORM_COLLECTION: "DELETE_POST_FORM_COLLECTION",
    EDIT_POST_FORM_COLLECTION: "EDIT_POST_FORM_COLLECTION",
};
